export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="px-4 md:px-6 max-w-4xl mx-auto">
        <div className="bg-background-100 rounded-2xl border border-background-200/70 p-6 md:p-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-5">关于吃瓜爆料网</h2>

          <div className="space-y-4 text-sm md:text-base text-foreground-600 leading-relaxed">
            <p>
              吃瓜爆料网诞生于娱乐资讯爆炸的时代，致力于为吃瓜群众打造一个干净、高效、直达核心的一手爆料聚合平台。我们不造瓜，只做优质吃瓜内容的搬运工和导航者。
            </p>
            <p>
              从博主反差视频到明星塌房现场，从圈内黑料爆料到热门话题追踪，吃瓜爆料网覆盖娱乐八卦的全品类内容。我们深知在收藏夹里存着一堆随时可能失效的地址有多痛苦，因此建立了持续更新的官方发布机制——本站提供的吃瓜爆料网App下载链接、网站入口和最新地址始终保持有效。
            </p>
            <p>
              吃瓜爆料网团队由资深娱乐媒体人和技术极客组成，我们用技术的确定性对抗信息的不确定性。无论你是在地铁上刷手机，还是在电脑前摸鱼，吃瓜爆料网都能让你第一时间触达最热的娱乐资讯。
            </p>
          </div>

          <div className="mt-6 grid grid-cols-1 sm:grid-cols-3 gap-4">
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="text-2xl font-heading text-primary-500 mb-1">3年+</div>
              <div className="text-xs text-foreground-500">持续运营</div>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="text-2xl font-heading text-accent-500 mb-1">百万+</div>
              <div className="text-xs text-foreground-500">忠实用户</div>
            </div>
            <div className="text-center p-4 rounded-xl bg-background-50">
              <div className="text-2xl font-heading text-secondary-500 mb-1">24h</div>
              <div className="text-xs text-foreground-500">全天候更新</div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}